import * as React from 'react';
import { SVGProps } from 'react';

const IconMapFilledSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m3 7.15 4-2.1V17.9L3 20V7.15ZM15 19.12l-6-1.574V4.879l6 1.575v12.667ZM17 18.95l4-2.1V4l-4 2.1v12.85Z" />
  </svg>
);
export default IconMapFilledSizeM;
